import React from 'react';
import API from "../../Services/BaseService";
import { useHistory, useParams } from "react-router-dom";
// import '../../assets/css/styles.css';
import AboutusImg from '../../../src/assets/img/aboutusimg.png';
import AppStoreImg from '../../../src/assets/img/appstore.png';
import GooglePlayImg from '../../../src/assets/img/googleplay.png';
import { useState } from 'react';
import { useEffect } from 'react';
import {
  Form,
  Input,
  Select,
  AutoComplete,
  Radio,
  notification,
  Spin,
} from 'antd';

import { Modal, Button } from 'antd';
import  '../Aboutus/Aboutus.css';

const Aboutus = () => {

  const history = useHistory();
  // const [isLateFee, setIsLateFee] = useState(false);
  // const [lateFeeValue, setLateFeeValue] = useState(0);

  // const toggleLateFee = () => {
  //   setIsLateFee(!isLateFee);
  // }


  // const getlateFee=()=>{
  //   let request={
  //     buyer_dealer_id: JSON.parse(localStorage.getItem("userDetails")).buyer_dealer_id
  //   }

  //   API.post('getlatefee/condition',request).then(res=>{
  //      if(res.data.data.length){

  //    console.log("check +++++ ", res.data.data.filter(value=>value.status=="yes")[0]?.status || "no" )
  //     const lateFeeValueStatus=res.data.data.filter(value=>value.status=="yes")[0]?.status || "no" 
  //     setIsLateFee(lateFeeValueStatus==="yes")
  //     setLateFeeValue(res.data.data.filter(value=>value.late_fee>0)[0]?.late_fee || 0)
  //      }


  //   }).catch(err=>{console.log(err);});
  // }


  // useEffect(() => {

  //   getlateFee();

  // }, []);

  return (
    <div>
      <main id="main" className="inner-page">

        <div id="about" className="about">
          <div className="container" >
            <div className="aboutblock col-lg-12">

              <div className="section-title">
                <h2>About Us</h2>
              </div>

              <div className="row content">
                <div className="col-lg-4">
                  <div className="aboutusimg">
                    <img src={AboutusImg} />
                  </div>

                </div>
                <div className="col-lg-8 pt-4 pt-lg-0">
                  <div class="about-sub-title">
                    <h4>INTEGRITY  HONESTY AFFORDABLE PRICE IS OUR GOAL</h4>
                  </div>
                  <p>
                    We have experience in the field of the auction industry since the 1990s.We strive ourselves to keep up with innovation and technology.
                    We believe that this platform will help dealers just with a click at the fingertips purchase or sell a car from the comfort of a favorite device.
                    it is our priority to provide transparency,integrity and a more affordable and effective way to wholesale a car nationwide.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>




        <section id="playstoreBlock" className="playstoreBlock">
          <div className="container">
            <div className="row content">
              <div className="col-lg-12">
                <img src={AppStoreImg} />
                <img src={GooglePlayImg} />
              </div>
            </div>
          </div>
        </section>




      </main>
    </div>
  );
};

export default Aboutus;   